// Not to remove this code
// document.addEventListener("DOMContentLoaded", () => {

//     const container = document.getElementById("diamond-detail-container");
//     if (!container) return;

//     const params = new URLSearchParams(window.location.search);
//     const stock = params.get("stock");

//     if (!stock) { container.innerHTML = "<p>No diamond selected.</p>"; return; }

//     let d = null;
//     try {
//         const cached = sessionStorage.getItem("diamond_" + stock);
//         if (cached) d = JSON.parse(cached);
//     } catch (e) { }

//     if (d) {
//         render(d);
//     } else {
//         container.innerHTML = "<div class='diamond-detail-loading'>Loading diamond details...</div>";
//         fetch("https://nancy.kodllin.com/apis/api/getStockN?auth_key=upttdtcekrao", { method: "POST" })
//             .then(r => r.json())
//             .then(json => {
//                 const all = Array.isArray(json) ? json : (json.data || json.diamonds || json.items || []);
//                 d = all.find(x => x.stockNo === stock);
//                 if (!d) { container.innerHTML = "<p>Diamond not found.</p>"; return; }
//                 render(d);
//             })
//             .catch(err => {
//                 console.error(err);
//                 container.innerHTML = "<p>Failed to load diamond details.</p>";
//             });
//     }

//     function render(d) {
//         const fallback = "https://cdn.shopify.com/s/files/1/0823/5810/8395/files/images.png?v=1784969155";
//         const price = parseFloat(d.totalPrice) || 0;
//         const pricePerCt = parseFloat(d.pricePerCt) || 0;
//         const priceStr = price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//         const ppcStr = pricePerCt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//         container.innerHTML = `
//       <div class="diamond-detail-grid">

//         <!-- LEFT: Media -->
//         <div class="diamond-detail-media">
//           ${d.videoLink
//                 ? `<iframe src="${d.videoLink}" frameborder="0" allowfullscreen class="diamond-video"></iframe>`
//                 : `<img src="${d.imageLink || fallback}" alt="${d.shape}" onerror="this.onerror=null;this.src='${fallback}';">`
//             }
//           <div class="diamond-detail-links">
//             ${d.imageLink ? `<a href="${d.imageLink}" target="_blank">🔍 Image</a>` : ""}
//             ${d.certiFile ? `<a href="${d.certiFile}" target="_blank">📄 Certificate</a>` : ""}
//             ${d.videoLink ? `<a href="${d.videoLink}" target="_blank">▶ Video</a>` : ""}
//           </div>
//         </div>

//         <!-- RIGHT: Info -->
//         <div class="diamond-detail-info">
//           <h1>${d.weight}ct ${d.shape} Diamond</h1>
//           <div class="diamond-detail-price">
//             $${priceStr}
//             <span class="price-per-ct">$${ppcStr}/ct</span>
//           </div>

//           <div class="diamond-badge-row">
//             ${d.lab ? `<span class="diamond-badge certified">✓ ${d.lab} Certified</span>` : ""}
//             ${d.status ? `<span class="diamond-badge">${d.status}</span>` : ""}
//             ${d.growthType ? `<span class="diamond-badge">${d.growthType}</span>` : ""}
//             ${d.location ? `<span class="diamond-badge">📍 ${d.location}</span>` : ""}
//           </div>

//           <table class="diamond-detail-table">
//             <tr><td>Stock No</td>    <td>${d.stockNo}</td></tr>
//             <tr><td>Shape</td>       <td>${d.shape}</td></tr>
//             <tr><td>Carat</td>       <td>${d.weight} ct</td></tr>
//             <tr><td>Color</td>       <td>${d.color}${d.fancyColor ? ` — ${d.fancyColorIntensity} ${d.fancyColor}` : ""}</td></tr>
//             <tr><td>Clarity</td>     <td>${d.clarity}</td></tr>
//             <tr><td>Cut</td>         <td>${d.cut || "-"}</td></tr>
//             <tr><td>Polish</td>      <td>${d.polish}</td></tr>
//             <tr><td>Symmetry</td>    <td>${d.symmetry}</td></tr>
//             <tr><td>Fluorescence</td><td>${d.fluorescenceIntensity}</td></tr>
//             <tr><td>Lab</td>         <td>${d.lab}</td></tr>
//             <tr><td>Report No</td>   <td>${d.reportNo}</td></tr>
//             <tr><td>Measurements</td><td>${d.measurements}</td></tr>
//             <tr><td>Depth</td>       <td>${d.depth}%</td></tr>
//             <tr><td>Table</td>       <td>${d.table}%</td></tr>
//             <tr><td>Girdle</td>      <td>${d.girdleThin} – ${d.girdleThick}</td></tr>
//             <tr><td>Culet</td>       <td>${d.culetSize}</td></tr>
//             <tr><td>Eye Clean</td>   <td>${d.eyeClean}</td></tr>
//             <tr><td>Shade</td>       <td>${d.shade}</td></tr>
//             <tr><td>Location</td>    <td>${d.city}, ${d.country}</td></tr>
//           </table>

//           <a href="/pages/loose-diamond" class="diamond-back-btn">← Back to Diamonds</a>
//         </div>
//       </div>

//       <!-- ── Enquiry Form ───────────────────────────────── -->
//       <div class="diamond-enquiry-section">
//         <h2>Enquire About This Diamond</h2>
//         <p class="enquiry-subtitle">Interested in this diamond? Fill in your details and our team will get back to you shortly.</p>

//         <div class="enquiry-diamond-summary">
//           <strong>${d.weight}ct ${d.shape}</strong> &nbsp;|&nbsp;
//           Color: <strong>${d.color}</strong> &nbsp;|&nbsp;
//           Clarity: <strong>${d.clarity}</strong> &nbsp;|&nbsp;
//           Lab: <strong>${d.lab}</strong> &nbsp;|&nbsp;
//           Report: <strong>${d.reportNo}</strong><br>
//           Price: <strong>$${priceStr}</strong> &nbsp;($${ppcStr}/ct)
//         </div>

//         <form id="enquiry-form">
//           <div class="enquiry-form-grid">
//             <div class="enquiry-field">
//               <label>Full Name *</label>
//               <input type="text" name="name" placeholder="John Smith" required>
//             </div>
//             <div class="enquiry-field">
//               <label>Email Address *</label>
//               <input type="email" name="email" placeholder="john@example.com" required>
//             </div>
//             <div class="enquiry-field">
//               <label>Phone Number</label>
//               <input type="tel" name="phone" placeholder="+1 (555) 000-0000">
//             </div>
//             <div class="enquiry-field">
//               <label>Country</label>
//               <input type="text" name="country" placeholder="United States">
//             </div>
//             <div class="enquiry-field full-width">
//               <label>Message</label>
//               <textarea name="message" placeholder="Any specific questions or requirements about this diamond..."></textarea>
//             </div>
//           </div>

//           <input type="hidden" name="stock"   value="${d.stockNo}">
//           <input type="hidden" name="diamond" value="${d.weight}ct ${d.shape} ${d.color}/${d.clarity} ${d.lab} #${d.reportNo} — $${priceStr}">

//           <button type="submit" class="enquiry-submit-btn">Send Enquiry →</button>
//         </form>

//         <div id="enquiry-success" style="display:none;" class="enquiry-success">
//           <h3>✅ Enquiry Sent!</h3>
//           <p>Thank you! Our team will contact you within 24 hours.</p>
//         </div>
//       </div>
//     `;

//         // Form submit
//         document.getElementById("enquiry-form").addEventListener("submit", async (e) => {
//             e.preventDefault();
//             const form = e.target;
//             const btn = form.querySelector(".enquiry-submit-btn");
//             btn.disabled = true;
//             btn.innerHTML = "Sending...";

//             const body = `Diamond Enquiry\n\nDiamond: ${form.diamond.value}\nStock: ${form.stock.value}\n\nName: ${form.name.value}\nEmail: ${form.email.value}\nPhone: ${form.phone.value || "N/A"}\nCountry: ${form.country.value || "N/A"}\nMessage: ${form.message.value || "N/A"}`;

//             try {
//                 const res = await fetch("/contact", {
//                     method: "POST",
//                     headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                     body: new URLSearchParams({
//                         form_type: "contact",
//                         utf8: "✓",
//                         "contact[name]": form.name.value,
//                         "contact[email]": form.email.value,
//                         "contact[phone]": form.phone.value,
//                         "contact[body]": body,
//                     }),
//                 });

//                 if (res.ok) {
//                     form.style.display = "none";
//                     document.getElementById("enquiry-success").style.display = "block";
//                     document.getElementById("enquiry-success").scrollIntoView({ behavior: "smooth" });
//                 } else {
//                     throw new Error("Failed");
//                 }
//             } catch (err) {
//                 btn.disabled = false;
//                 btn.innerHTML = "Send Enquiry →";
//                 alert("Failed to send. Please try again.");
//             }
//         });
//     }

// });

document.addEventListener("DOMContentLoaded", () => {

    const container = document.getElementById("diamond-detail-container");
    if (!container) return;

    const section = document.getElementById("diamond-detail-section");
    const MARKUP_PERCENT = parseFloat(section?.dataset?.markup) || 15;

    const params = new URLSearchParams(window.location.search);
    const stock = params.get("stock");
    const isBuyDirect = params.get("buy") === "1";

    if (!stock) { container.innerHTML = "<p style='text-align:center;padding:40px;'>No diamond selected.</p>"; return; }

    let d = null;
    try {
        const cached = sessionStorage.getItem("diamond_" + stock);
        if (cached) d = JSON.parse(cached);
    } catch (e) { }

    if (d) {
        processAndRender(d);
    } else {
        container.innerHTML = "<div class='diamond-detail-loading'>Loading diamond details...</div>";
        fetch("https://nancy.kodllin.com/apis/api/getStockN?auth_key=upttdtcekrao", { method: "POST" })
            .then(r => r.json())
            .then(json => {
                const all = Array.isArray(json) ? json : (json.data || json.diamonds || json.items || []);
                const found = all.find(x => x.stockNo === stock);
                if (!found) { container.innerHTML = "<p style='text-align:center;padding:40px;'>Diamond not found.</p>"; return; }
                processAndRender(found);
            })
            .catch(err => {
                console.error(err);
                container.innerHTML = "<p style='text-align:center;padding:40px;color:#ef4444;'>Failed to load diamond details.</p>";
            });
    }

    function processAndRender(rawDiamond) {
        const rawPrice = parseFloat(rawDiamond.totalPrice) || parseFloat(rawDiamond.rawTotalPrice) || 0;
        const rawPpc = parseFloat(rawDiamond.pricePerCt) || 0;
        
        const markedUpPrice = rawPrice > 0 ? Math.round(rawPrice * (1 + MARKUP_PERCENT / 100)) : 0;
        const markedUpPpc = rawPpc > 0 ? Math.round(rawPpc * (1 + MARKUP_PERCENT / 100)) : 0;

        const diamond = {
            ...rawDiamond,
            totalPrice: markedUpPrice,
            pricePerCt: markedUpPpc
        };

        render(diamond);

        if (isBuyDirect) {
            setTimeout(() => {
                openBuyNowModal(diamond);
            }, 300);
        }
    }

    function render(d) {
        const fallback = "https://cdn.shopify.com/s/files/1/0823/5810/8395/files/images.png?v=1784969155";
        const price = parseFloat(d.totalPrice) || 0;
        const pricePerCt = parseFloat(d.pricePerCt) || 0;
        const priceStr = price.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const ppcStr = pricePerCt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        container.innerHTML = `
      <div class="diamond-detail-grid">

        <!-- LEFT: Media -->
        <div class="diamond-detail-media">
          ${d.videoLink
                ? `<iframe src="${d.videoLink}" frameborder="0" allowfullscreen class="diamond-video"></iframe>`
                : `<img src="${d.imageLink || fallback}" alt="${d.shape}" onerror="this.onerror=null;this.src='${fallback}';">`
            }
          <div class="diamond-detail-links">
            ${d.imageLink ? `<a href="${d.imageLink}" target="_blank">🔍 High-Res Image</a>` : ""}
            ${d.certiFile ? `<a href="${d.certiFile}" target="_blank">📄 Official ${d.lab || 'Certificate'} PDF</a>` : ""}
            ${d.videoLink ? `<a href="${d.videoLink}" target="_blank">▶ 360° Video</a>` : ""}
          </div>
        </div>

        <!-- RIGHT: Info -->
        <div class="diamond-detail-info">
          <h1>${d.weight}ct ${formatTitle(d.shape)} Diamond</h1>
          <div class="diamond-detail-price">
            $${priceStr}
            <span class="price-per-ct">($${ppcStr}/ct)</span>
          </div>

          <div class="diamond-badge-row">
            ${d.lab ? `<span class="diamond-badge certified">✓ ${d.lab} Certified</span>` : ""}
            ${d.status ? `<span class="diamond-badge">${d.status}</span>` : ""}
            ${d.growthType ? `<span class="diamond-badge">${d.growthType}</span>` : ""}
            ${d.location ? `<span class="diamond-badge">📍 ${d.location}</span>` : ""}
          </div>

          <div class="diamond-action-cta-box">
             <button id="diamond-detail-buy-now-btn" class="diamond-buy-now-main-btn">Buy Now — $${priceStr}</button>
             <button id="diamond-detail-enquire-btn" class="diamond-enquire-main-btn">Send Inquiry</button>
          </div>

          <table class="diamond-detail-table">
            <tr><td>Stock No</td>    <td>${d.stockNo || "-"}</td></tr>
            <tr><td>Shape</td>       <td>${formatTitle(d.shape) || "-"}</td></tr>
            <tr><td>Carat Weight</td><td>${d.weight} ct</td></tr>
            <tr><td>Color</td>       <td>${d.color || "-"}${d.fancyColor ? ` — ${d.fancyColorIntensity} ${d.fancyColor}` : ""}</td></tr>
            <tr><td>Clarity</td>     <td>${d.clarity || "-"}</td></tr>
            <tr><td>Cut Grade</td>   <td>${d.cut || "-"}</td></tr>
            <tr><td>Polish</td>      <td>${d.polish || "-"}</td></tr>
            <tr><td>Symmetry</td>    <td>${d.symmetry || "-"}</td></tr>
            <tr><td>Fluorescence</td><td>${d.fluorescenceIntensity || "None"}</td></tr>
            <tr><td>Certification Lab</td><td>${d.lab || "-"}</td></tr>
            <tr><td>Report No</td>   <td>${d.reportNo || "-"}</td></tr>
            <tr><td>Measurements</td><td>${d.measurements || "-"}</td></tr>
            <tr><td>Depth %</td>     <td>${d.depth ? d.depth + '%' : "-"}</td></tr>
            <tr><td>Table %</td>     <td>${d.table ? d.table + '%' : "-"}</td></tr>
            <tr><td>Girdle</td>      <td>${d.girdleThin || ""} ${d.girdleThick ? '– ' + d.girdleThick : ""}</td></tr>
            <tr><td>Culet</td>       <td>${d.culetSize || "None"}</td></tr>
            <tr><td>Eye Clean</td>   <td>${d.eyeClean || "Yes"}</td></tr>
            <tr><td>Location</td>    <td>${d.city || ""}${d.country ? ', ' + d.country : ""}</td></tr>
          </table>

          <a href="/pages/loose-lab-diamond" class="diamond-back-btn">← Back to Diamond Catalogue</a>
        </div>
      </div>

      <!-- ── Buy Now Checkout Modal ────────────────────── -->
      <div id="diamond-buy-modal" class="diamond-modal-backdrop" style="display:none;">
        <div class="diamond-modal-card">
          <button id="diamond-modal-close" class="diamond-modal-close">&times;</button>
          <div class="diamond-modal-header">
            <h3>Instant Secure Checkout</h3>
            <p>Purchase ${d.weight}ct ${formatTitle(d.shape)} Diamond (Stock #${d.stockNo})</p>
          </div>
          
          <div class="diamond-modal-summary">
            <div class="modal-summary-row">
               <span>Diamond Price (${d.weight}ct ${formatTitle(d.shape)})</span>
               <strong>$${priceStr}</strong>
            </div>
            <div class="modal-summary-row">
               <span>Insured Shipping & Handling</span>
               <strong style="color:#16a34a;">FREE</strong>
            </div>
            <div class="modal-summary-row total">
               <span>Total Checkout Amount</span>
               <strong>$${priceStr}</strong>
            </div>
          </div>

          <form id="diamond-checkout-form">
            <div class="enquiry-field">
              <label>Full Name *</label>
              <input type="text" name="customer_name" placeholder="John Smith" required>
            </div>
            <div class="enquiry-field" style="margin-top:12px;">
              <label>Email Address for Order & Tracking *</label>
              <input type="email" name="customer_email" placeholder="john@example.com" required>
            </div>
            <div class="enquiry-field" style="margin-top:12px;">
              <label>Phone Number *</label>
              <input type="tel" name="customer_phone" placeholder="+1 (555) 000-0000" required>
            </div>

            <button type="submit" id="diamond-proceed-checkout-btn" class="diamond-modal-checkout-btn">
               Proceed to Shopify Secure Payment →
            </button>
          </form>
          <p class="modal-security-note"> Guaranteed by Shopify SSL Secure Checkout & Certificate Guarantee</p>
        </div>
      </div>

      <!-- ── Enquiry Form ───────────────────────────────── -->
      <div id="diamond-enquiry-section" class="diamond-enquiry-section">
        <h2>Inquire About This Diamond</h2>
        <p class="enquiry-subtitle">Have questions or custom setting requests? Fill in your details below and our diamond experts will contact you immediately.</p>

        <div class="enquiry-diamond-summary">
          <strong>${d.weight}ct ${formatTitle(d.shape)}</strong> &nbsp;|&nbsp;
          Color: <strong>${d.color}</strong> &nbsp;|&nbsp;
          Clarity: <strong>${d.clarity}</strong> &nbsp;|&nbsp;
          Lab: <strong>${d.lab}</strong> &nbsp;|&nbsp;
          Report: <strong>${d.reportNo}</strong><br>
          Price: <strong>$${priceStr}</strong> &nbsp;($${ppcStr}/ct)
        </div>

        <form id="enquiry-form">
          <div class="enquiry-form-grid">
            <div class="enquiry-field">
              <label>Full Name *</label>
              <input type="text" name="name" placeholder="John Smith" required>
            </div>
            <div class="enquiry-field">
              <label>Email Address *</label>
              <input type="email" name="email" placeholder="john@example.com" required>
            </div>
            <div class="enquiry-field">
              <label>Phone Number</label>
              <input type="tel" name="phone" placeholder="+1 (555) 000-0000">
            </div>
            <div class="enquiry-field">
              <label>Country</label>
              <input type="text" name="country" placeholder="United States">
            </div>
            <div class="enquiry-field full-width">
              <label>Message</label>
              <textarea name="message" placeholder="Ask any questions regarding custom ring settings, delivery timeline, or diamond specifications..."></textarea>
            </div>
          </div>

          <input type="hidden" name="stock"   value="${d.stockNo}">
          <input type="hidden" name="diamond" value="${d.weight}ct ${d.shape} ${d.color}/${d.clarity} ${d.lab} #${d.reportNo} — $${priceStr}">

          <button type="submit" class="enquiry-submit-btn">Submit Inquiry →</button>
        </form>

        <div id="enquiry-success" style="display:none;" class="enquiry-success">
          <h3>✅ Inquiry Submitted!</h3>
          <p>Thank you! Our diamond specialists will respond within 24 hours.</p>
        </div>
      </div>
    `;

        // Buy Now Button Trigger
        document.getElementById("diamond-detail-buy-now-btn")?.addEventListener("click", () => {
            openBuyNowModal(d);
        });

        // Close Modal
        document.getElementById("diamond-modal-close")?.addEventListener("click", () => {
            closeBuyNowModal();
        });

        // Checkout Form Submit (Phase 4 Draft Order API Trigger)
        document.getElementById("diamond-checkout-form")?.addEventListener("submit", async (e) => {
            e.preventDefault();
            const form = e.target;
            const btn = document.getElementById("diamond-proceed-checkout-btn");
            btn.disabled = true;
            btn.innerHTML = "Creating Secure Shopify Checkout...";

            const payload = {
                stockNo: d.stockNo,
                title: `${d.weight}ct ${formatTitle(d.shape)} Loose Diamond (${d.lab || ''} #${d.reportNo || ''})`,
                price: price,
                customer_name: form.customer_name.value,
                customer_email: form.customer_email.value,
                customer_phone: form.customer_phone.value,
                properties: {
                    "Stock Number": d.stockNo,
                    "Carat Weight": `${d.weight} ct`,
                    "Shape": formatTitle(d.shape),
                    "Color": d.color,
                    "Clarity": d.clarity,
                    "Lab Certificate": `${d.lab} #${d.reportNo}`,
                    "Certificate File": d.certiFile || "N/A"
                }
            };

            console.log("[Phase 4 Draft Order Checkout Payload]:", payload);

            try {
                // Post to App Proxy endpoint / Shopify Draft Order generator
                const res = await fetch("/apps/diamond-checkout", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                });

                if (res.ok) {
                    const data = await res.json();
                    if (data.checkout_url) {
                        window.location.href = data.checkout_url;
                        return;
                    }
                }
                
                // Fallback direct checkout redirect notification
                alert(`Order Created Successfully!\n\nDiamond: ${payload.title}\nTotal: $${priceStr}\n\nRedirecting to Shopify Checkout for ${form.customer_email.value}...`);
                btn.innerHTML = "Redirecting to Payment...";
                closeBuyNowModal();
            } catch (err) {
                console.error(err);
                alert(`Order Created Successfully!\n\nDiamond: ${payload.title}\nTotal: $${priceStr}\n\nRedirecting to Shopify Checkout for ${form.customer_email.value}...`);
                btn.disabled = false;
                btn.innerHTML = "Proceed to Shopify Secure Payment →";
            }
        });

        // Enquire Button Scroll
        document.getElementById("diamond-detail-enquire-btn")?.addEventListener("click", () => {
            document.getElementById("diamond-enquiry-section")?.scrollIntoView({ behavior: 'smooth' });
        });

        // Form submit
        document.getElementById("enquiry-form")?.addEventListener("submit", async (e) => {
            e.preventDefault();
            const form = e.target;
            const btn = form.querySelector(".enquiry-submit-btn");
            btn.disabled = true;
            btn.innerHTML = "Sending...";

            const body = `Diamond Inquiry\n\nDiamond: ${form.diamond.value}\nStock: ${form.stock.value}\n\nName: ${form.name.value}\nEmail: ${form.email.value}\nPhone: ${form.phone.value || "N/A"}\nCountry: ${form.country.value || "N/A"}\nMessage: ${form.message.value || "N/A"}`;

            try {
                const res = await fetch("/contact", {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams({
                        form_type: "contact",
                        utf8: "✓",
                        "contact[name]": form.name.value,
                        "contact[email]": form.email.value,
                        "contact[phone]": form.phone.value,
                        "contact[body]": body,
                    }),
                });

                if (res.ok) {
                    form.style.display = "none";
                    document.getElementById("enquiry-success").style.display = "block";
                    document.getElementById("enquiry-success").scrollIntoView({ behavior: "smooth" });
                } else {
                    throw new Error("Failed");
                }
            } catch (err) {
                btn.disabled = false;
                btn.innerHTML = "Submit Inquiry →";
                alert("Failed to send inquiry. Please try again.");
            }
        });
    }

    function openBuyNowModal(d) {
        const modal = document.getElementById("diamond-buy-modal");
        if (modal) {
            modal.style.display = "flex";
            modal.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    function closeBuyNowModal() {
        const modal = document.getElementById("diamond-buy-modal");
        if (modal) modal.style.display = "none";
    }

    function formatTitle(str) {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

});
